module.exports = __webpack_public_path__ + "img/NoDocuments.7b66798a.svg";